import { Bars3Icon, Squares2X2Icon } from "@heroicons/react/24/outline";
import styles from "./TaskViewToggle.module.css";

export type TaskViewValue = "list" | "grid";

export interface TaskViewToggleProps {
	value: TaskViewValue;
	onChange: (next: TaskViewValue) => void;
	listLabel: string;
	gridLabel: string;
}

export function TaskViewToggle({
	value,
	onChange,
	listLabel,
	gridLabel,
}: TaskViewToggleProps) {
	return (
		<div className={styles.container}>
			<button
				type="button"
				aria-label={listLabel}
				aria-pressed={value === "list"}
				data-active={value === "list"}
				className={styles.button}
				onClick={() => onChange("list")}
			>
				<Bars3Icon className={styles.icon} aria-hidden="true" />
			</button>
			<button
				type="button"
				aria-label={gridLabel}
				aria-pressed={value === "grid"}
				data-active={value === "grid"}
				className={styles.button}
				onClick={() => onChange("grid")}
			>
				<Squares2X2Icon className={styles.icon} aria-hidden="true" />
			</button>
		</div>
	);
}
